import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { QuantumDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-quantum',
  templateUrl: './quantum.component.html',
  styleUrls: ['./quantum.component.scss'],
})
export class QuantumComponent implements OnChanges {
  quantumForm: FormGroup;
  quantumFormArray: FormGroup;
  control = new FormControl();
  @Input() quantums: QuantumDto[];
  @Input() routeAnimationsElements: any;
  @Output() quantum = new EventEmitter<QuantumDto[]>();
  @Output() deleteQuantumEvent = new EventEmitter<any>();

  selectedQuantum: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createQuantumForm();
  }

  createQuantumForm() {
    this.quantumForm = this.fb.group({
      QuantumName: ['', Validators.required],
      DistributorFactorValue: ['', Validators.required],
      DistributorFactorName: ['', Validators.required],
      id: null,
    });
    this.quantumFormArray = this.fb.group({
      Quantums: this.fb.array([]),
    });
    this.setQuantum();
  }

  // method to display quantums
  setQuantum() {
    const control = this.quantumFormArray.controls.Quantums as FormArray;
    this.quantums.forEach((e) => {
      control.push(
        this.fb.group({
          QuantumName: e.QuantumName,
          DistributorFactorValue: e.DistributorFactorValue,
          DistributorFactorName: e.DistributorFactorName,
          id: e.id,
        })
      );
    });
  }

  // method to add Quantum
  addQuantum(value: QuantumDto) {
    const control = this.quantumFormArray.controls.Quantums as FormArray;
    control.insert(
      0,
      this.fb.group({
        QuantumName: value.QuantumName,
        DistributorFactorValue: value.DistributorFactorValue,
        DistributorFactorName: value.DistributorFactorName,
        id: null,
      })
    );
  }

  selectQuantum(value) {}

  // method to delete quantum from arrary list
  deleteQuantum(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.quantumFormArray.controls.Quantums as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.quantums.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.quantums[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: QuantumDto) {
    if (this.quantumForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.quantumFormArray
        .get('Quantums')
        ['controls'][this.selectedIndex].patchValue({
          QuantumName: formValue.QuantumName,
        });
    } else {
      this.addQuantum(formValue);
    }
    this.selectedIndex = null;
    this.quantumForm.reset();
  }

  onEdit(index, value: QuantumDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.quantumForm.patchValue({ QuantumName: value.QuantumName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.quantumForm.reset();
  }

  onSubmit(formValue: QuantumDto[]) {
    this.quantum.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteQuantumEvent.emit(this.filteredDelete);
    }
  }
}
